export default "__VITE_ASSET__286a6c7d__"